import "../Tooltip.css";
import "./GenericTooltip.css";

import Tooltip from "rc-tooltip";
import { ReactElement } from "react";

import { useTooltip } from "../useTooltip";

export interface GenericTooltipProps {
  content: ReactElement;
  children: ReactElement;
  placement?:
    | "top"
    | "left"
    | "right"
    | "bottom"
    | "topLeft"
    | "topRight"
    | "bottomLeft"
    | "bottomRight"
    | "leftTop"
    | "leftBottom"
    | "rightTop"
    | "rightBottom";
}

export const GenericTooltip = ({ content, children, placement = "bottom" }: GenericTooltipProps): JSX.Element => {
  const { isVisible, handleVisibleChange } = useTooltip();

  return (
    <Tooltip
      placement={placement}
      visible={isVisible}
      onVisibleChange={(visible: boolean) => handleVisibleChange(visible)}
      classNames={{ root: "KanaTooltip GenericTooltip" }}
      overlay={content}
    >
      {children}
    </Tooltip>
  );
};
